import I18n from 'I18n';
import { getFile, getLocalId } from 'conversations-internal-schema/file-upload/operators/fileUploadGetters';
import { List } from 'immutable';
import { useEffect, useRef } from 'react';
import { useAriaLiveContext } from 'visitor-ui-component-library/utils/aria-live/AriaLiveContext';
import { getIsPortal53 } from '../../widget-data/operators/getIsPortal53';
import { INVALID_FILE_TYPE, SIZE_LIMIT_EXCEEDED, UPLOAD_ERROR } from '../constants/attachmentErrors';
import { MAX_FILE_SIZE, MAX_FILE_SIZE_PORTAL_53 } from '../constants/fileUploadsConstants';
export const useFileUploadAnnouncements = (stagedAttachments, attachmentsError) => {
  const {
    announce
  } = useAriaLiveContext();
  const previousAttachmentRef = useRef(null);
  const previousAttachmentsListRef = useRef(List());
  const previousErrorRef = useRef(attachmentsError);
  useEffect(() => {
    const currentAttachment = stagedAttachments.first();
    if (!currentAttachment) {
      previousAttachmentRef.current = null;
      return;
    }
    const prevAttachment = previousAttachmentRef.current;
    if (prevAttachment) {
      const prevFileId = prevAttachment.get('fileId');
      const currentFileId = currentAttachment.get('fileId');
      const currentProgress = currentAttachment.get('uploadProgress') || 0;
      if (prevFileId === -1 && currentFileId && currentProgress === 100) {
        const file = getFile(currentAttachment);
        const fileName = (file === null || file === void 0 ? void 0 : file.name) || 'File';
        const currentLocalId = getLocalId(currentAttachment);
        announce({
          id: `upload-complete-${currentLocalId}`,
          text: I18n.text('cvVisitorUIAttachments.uploadComplete', {
            fileName
          })
        }, 'assertive');
      }
    }
    previousAttachmentRef.current = currentAttachment;
  }, [stagedAttachments, announce]);
  useEffect(() => {
    const previousError = previousErrorRef.current;
    if (attachmentsError && attachmentsError !== previousError) {
      const errorMessage = (() => {
        switch (attachmentsError) {
          case SIZE_LIMIT_EXCEEDED:
            return I18n.text('cvVisitorUIAttachments.errors.fileSizeExceededAnnouncement', {
              maxSize: I18n.formatSize(getIsPortal53() ? MAX_FILE_SIZE_PORTAL_53 : MAX_FILE_SIZE)
            });
          case INVALID_FILE_TYPE:
            return I18n.text('cvVisitorUIAttachments.errors.invalidFileTypeAnnouncement');
          case UPLOAD_ERROR:
          default:
            return I18n.text('cvVisitorUIAttachments.errors.uploadErrorAnnouncement');
        }
      })();
      announce({
        id: `upload-error-${Date.now()}`,
        text: errorMessage
      }, 'assertive');
    }
    previousErrorRef.current = attachmentsError;
  }, [attachmentsError, announce]);
  useEffect(() => {
    const previousList = previousAttachmentsListRef.current;
    if (previousList.size > stagedAttachments.size) {
      const removedAttachment = previousList.find(prevAttachment => !stagedAttachments.some(currentAttachment => getLocalId(currentAttachment) === getLocalId(prevAttachment)));
      if (removedAttachment) {
        const file = getFile(removedAttachment);
        const fileName = (file === null || file === void 0 ? void 0 : file.name) || 'File';
        announce({
          id: `attachment-removed-${Date.now()}`,
          text: I18n.text('cvVisitorUIAttachments.attachmentRemoved', {
            fileName
          })
        }, 'assertive');
      }
    }
    previousAttachmentsListRef.current = stagedAttachments;
  }, [stagedAttachments, announce]);
};